/**
 * ETV-Einladung (create/edit): documents redirect, POST save to Lux DB.
 * Shared state: lib/fetch/ownersMeetingInvitation.js
 */
;(function registerLuxFetchHandlerOwnersMeetingInvitation() {
  /** Must match entryPoints.js ownersMeetingInvitationPage (create + edit segments). */
  const INVITATION_FORM_PATH_RE = /^\/owners-meeting\/invitation\/(?:edit\/[A-Za-z0-9]+|create)$/
  const documentsPathRe = /\/services\/pmp-accounting\/api\/v1\/owners-meeting-invitations\/(\d+)\/documents/

  function getInvitationIdFromPath() {
    const m = window.location.pathname.match(/\/owners-meeting\/invitation\/edit\/(\d+)/)
    return m ? parseInt(m[1], 10) : null
  }

  luxRegisterFetchHandler({
    id: 'owners-meeting-invitation',
    priority: 40,
    match(ctx) {
      if (!INVITATION_FORM_PATH_RE.test(ctx.pathname)) return false
      if (ctx.url.match(documentsPathRe)) return true
      if (
        ctx.url.includes('/services/pmp-accounting/api/v1/owners-meeting-invitations') &&
        ctx.method === 'POST'
      ) {
        return true
      }
      return false
    },
    handle(ctx, nativeFetch) {
      const match = ctx.url.match(documentsPathRe)
      if (match != null) {
        const sourceId = match[1]
        window.location.replace(
          `/nachrichtenversand?type=owners-meeting-invitation&sourceIds=${sourceId}`,
        )
        return Promise.resolve(
          new Response(JSON.stringify([]), {
            status: 200,
            headers: { 'Content-Type': 'application/json' },
          }),
        )
      }

      return nativeFetch.apply(this, ctx.args).then((res) => {
        res
          .clone()
          .json()
          .then((data) => {
            const item = Array.isArray(data) ? data[0] : data
            let invitationId = item?.id != null ? Number(item.id) : null
            if (!invitationId || Number.isNaN(invitationId)) {
              invitationId = getInvitationIdFromPath()
            }
            if (!invitationId) return

            const documentDate = luxOwnersMeetingInvitationFetchState.lastDocumentDate.trim() || null

            const auth = JSON.parse(localStorage.getItem('auth') || '{}')
            const token = auth?.token || null
            if (!token) return

            const doFetch = window.luxNativeFetch || nativeFetch
            doFetch('/api/impowerX/owners-meeting-invitation', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                invitationId,
                documentDate,
                includeInformationForOwners:
                  luxOwnersMeetingInvitationFetchState.lastIncludeInformationForOwners,
              }),
              credentials: 'same-origin',
            }).catch((error) => {
              console.error('Error saving invitation data to DB:', error.message)
            })
          })
          .catch((error) => {
            console.error('Error saving invitation data to DB:', error.message)
          })
        return res
      })
    },
  })
})()
